import s from "./style.module.scss";
import { Files } from "../../core/reatom/state/currentService/currentService";
import { useEffect, useRef, useState } from "react";
import { UIButton } from "../UIButton/UIButton";
import dayjs from "dayjs";
import { Skeleton } from "@vkontakte/vkui";
import { Icon16Attach } from "@vkontakte/icons";
import { downloadFile } from "@telegram-apps/sdk-react";
import clsx from "clsx";
import { IsDocumentFile, IsVideoFile, IsSoundFile } from "@/core/helper/mime";

interface DescriptionProps {
  description?: string;
  files?: Files[];
  isLoading?: boolean;
  result?: string;
  requirements?: string;
  date_post?: number;
  date_edit?: number;
  autoExpand?: boolean;
}

export const Description = (props: DescriptionProps) => {
  const {
    description,
    files,
    isLoading,
    result,
    requirements,
    date_post,
    date_edit,
    autoExpand,
  } = props;
  // const [currentService] = useAtom(currentServiceAtom);
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLParagraphElement>(null);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const updateContentHeight = () => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  };

  useEffect(() => {
    updateContentHeight();

    const handleResize = () => {
      updateContentHeight();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [description]);

  const documentFiles = files?.filter((file) => IsDocumentFile(file.mime_type));
  const videoFiles = files?.filter((file) => IsVideoFile(file.mime_type));

  const audioFiles = files?.filter((file) => IsSoundFile(file.mime_type));
  return (
    <div className={s.outerwrapper}>
      {isLoading ? (
        <>
          <Skeleton margin={"2px 0 0 0"} />
          <Skeleton margin={"2px 0 0 0"} />
          <Skeleton margin={"2px 0 0 0"} />
          <Skeleton margin={"2px 0 0 0"} />
        </>
      ) : (
        <>
          <div className={s.wrapper}>
            <div
              ref={contentRef}
              className={clsx(s.expandWrapper, autoExpand && s.autoExpand)}
              style={{
                height: isExpanded ? `${contentHeight}px` : "48px",
              }}
            >
              <p className={s.description}>{description}</p>
              {result && (
                <>
                  <p className={s.title}>Заказчик получит:</p>
                  <p className={s.description}> {result}</p>
                </>
              )}
              {requirements && (
                <>
                  <p className={s.title}>
                    До начала работы заказчик должен предоставить:
                  </p>
                  <p className={s.description}>{requirements}</p>
                </>
              )}

              {files &&
                files.length > 0 &&
                (!!documentFiles?.length ||
                  !!audioFiles?.length ||
                  !!videoFiles?.length) && (
                  <>
                    <p className={s.title}>Вложенные файлы:</p>
                    <div className={s.files}>
                      {documentFiles &&
                        documentFiles.map((file) => (
                          <div
                            key={file.id}
                            className={s.document}
                            onClick={async () => {
                              if (downloadFile.isAvailable()) {
                                await downloadFile(file.url, file.name);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <Icon16Attach />
                            <p>{file.source_name}</p>
                          </div>
                        ))}

                      {audioFiles &&
                        audioFiles.map((file) => (
                          <audio
                            key={file.id}
                            src={file.url}
                            className={s.audio}
                            controls
                            onLoadedMetadata={(e) =>
                              (e.currentTarget.volume = 0.2)
                            }
                          />
                        ))}

                      {videoFiles &&
                        videoFiles.map((file) => (
                          <video
                            key={file.id}
                            src={file.url}
                            className={s.video}
                            controls
                            onLoadedMetadata={(e) =>
                              (e.currentTarget.volume = 0.2)
                            }
                          />
                        ))}
                    </div>
                  </>
                )}
              <div className={s.time}>
                {date_post && (
                  <p className={s.created}>
                    {"Опубликовано: "}
                    {dayjs(date_post).format("DD.MM.YYYY в HH:mm")}
                  </p>
                )}
                {date_edit && (
                  <p className={s.updated}>
                    {"Обновлено: "}
                    {dayjs(date_edit).format("DD.MM.YYYY в HH:mm")}
                  </p>
                )}
              </div>
            </div>
          </div>
          {!(contentHeight < 49) && (
            <UIButton
              onClick={() => toggleDescription()}
              fontType={"tertiary"}
              color="white"
              className={clsx(s.button, autoExpand && s.autoExpandButton)}
            >
              {isExpanded ? "Скрыть" : "Читать далее"}
            </UIButton>
          )}
        </>
      )}
    </div>
  );
};

export const AttachmentFile = () => {
  return (
    <div className={s.attachment} onClick={() => {}}>
      <Icon16Attach />
    </div>
  );
};
